import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ServiceRequestHistoryDataOut } from 'src/app/_modules/customers/_models/kyc-account-data';

@Component({
  selector: 'app-service-request-history-modal',
  templateUrl: './service-request-history-modal.component.html',
  styleUrls: ['./service-request-history-modal.component.scss'],
})
export class ServiceRequestHistoryModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() relatedAccountId: number | null = null;
  @Input() history: ServiceRequestHistoryDataOut[] = [];
  @Output() closed = new EventEmitter<void>();

  @ViewChild('modalBody') modalBody?: ElementRef<HTMLElement>;

  modalBodyMaxHeight: number | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['history'] || changes['visible']) {
      this.modalBodyMaxHeight = null;
      setTimeout(() => {
        const firstEntry = this.modalBody?.nativeElement.querySelector<HTMLElement>('.history-entry');
        this.modalBodyMaxHeight = firstEntry?.offsetHeight ?? null;
      });
    }
  }

  close() {
    this.closed.emit();
  }
}
